var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDeviceIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1822 6.20068H6.59116L5.67255 14.8587L6.59116 23.5166H13.1822V6.20068Z",
    fill: "#1592D2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M0 6.20068H6.59108V23.5166H0V6.20068Z",
    fill: "#32ADEC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8.65802 15.4329H10.4264V16.8108H8.65802V15.4329Z",
    fill: "#89F5F5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M16.6268 6.20067H15.2488C15.2488 5.06099 14.3216 4.13379 13.1819 4.13379V2.75586C15.0814 2.75586 16.6268 4.3012 16.6268 6.20067Z",
    fill: "#3AB9FB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3826 6.20067H18.0047C18.0047 3.54141 15.8412 1.37793 13.1819 1.37793V0C16.601 0 19.3826 2.78162 19.3826 6.20067Z",
    fill: "#1592D2"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeviceIcon);
export default __webpack_public_path__ + "static/media/DeviceIcon.43f65651b04becbe11fc69039ac53bd3.svg";
export { ForwardRef as ReactComponent };